export default __webpack_public_path__ + "static/media/Lato-Bold.5dd5aa02.ttf";